/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import produce from "immer";
import { call, put, takeLatest } from "redux-saga/effects";
import { getSearchResult, App, SearchReq } from "../../../api/apiCalls";
import {
  LoadingStatus,
  usePortalStateSelector,
} from "../../../rootReducer/actions";
import { MainPageEvent } from "../../MainUi";

export enum SearchResultsPageEvent {
  RESET = "RESET",
  GET_PAGE_DATA = "GET_PAGE_DATA",
  GET_PAGE_DATA_RESULT = "GET_PAGE_DATA_RESULT",
  GET_PAGE_DATA_FAIL = "GET_PAGE_DATA_FAIL",
}

export interface SearchResultsAction {
  type: SearchResultsPageEvent.GET_PAGE_DATA;
  payload: SearchReq;
}

export interface ResetSearchResults {
  type: SearchResultsPageEvent.RESET;
}

export interface SearchResultsSuccessAction {
  type: SearchResultsPageEvent.GET_PAGE_DATA_RESULT;
  results: {
    payload: App[];
    totalPages: number;
    pageNumber: number;
    totalElements: number;
  };
}

export interface SearchResultsActionFail {
  type: SearchResultsPageEvent.GET_PAGE_DATA_FAIL;
}

export type SearchResultsPageAction =
  | ResetSearchResults
  | SearchResultsAction
  | SearchResultsSuccessAction
  | SearchResultsActionFail;

export interface SearchResultsPageData {
  loadingStatus: LoadingStatus;
  apps: App[];
  pageNo: number;
  totalPages: number;
  totalElements: number;
  error: boolean;
}

const initialState = {
  loadingStatus: LoadingStatus.LOADING_STARTED,
  apps: [],
  pageNo: 0,
  totalPages: 0,
  totalElements: 0,
  error: false,
  notification: {
    show: false,
  },
};

export function SearchResultsPageReducer(
  state: SearchResultsPageData = initialState,
  action: SearchResultsPageAction
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SearchResultsPageEvent.GET_PAGE_DATA: {
        break;
      }

      case SearchResultsPageEvent.GET_PAGE_DATA_RESULT: {
        draft.loadingStatus = LoadingStatus.LOADING_SUCCESS;
        draft.apps = draft.apps.concat(action.results.payload);
        draft.pageNo = action.results.pageNumber;
        draft.totalPages = action.results.totalPages;
        draft.totalElements = action.results.totalElements;
        //TODO set any other value to the state here
        break;
      }

      case SearchResultsPageEvent.RESET: {
        draft.apps = [];
        draft.loadingStatus = LoadingStatus.LOADING_STARTED;
        break;
      }

      case SearchResultsPageEvent.GET_PAGE_DATA_FAIL: {
        draft.loadingStatus = LoadingStatus.LOADING_ERROR;
        break;
      }
    }
  });
}

export function useSearchResultsPageDataSelector(): SearchResultsPageData {
  return usePortalStateSelector<SearchResultsPageData>(
    (ev) => ev.searchResultsPageData
  );
}

export const searchResultsPageSagas = [getSearchResultsPageDataSaga];

function* getSearchResultsPageDataSaga() {
  yield takeLatest(
    SearchResultsPageEvent.GET_PAGE_DATA,
    callSearchResultsPageData
  );
}

const arr = ["E1008", "E1009", "E1010", "E1011", "E1012", "E1013"];

function* callSearchResultsPageData(action: SearchResultsAction) {
  try {
    const { payload, statusCode, totalPages, pageNumber, totalElements } =
      yield call(getSearchResult, action.payload);
    if (arr.includes(statusCode)) {
      yield put({
        type: MainPageEvent.SIGN_OUT_SUCCESS,
      });
      yield put({
        type: MainPageEvent.SHOW_NOTIFICATION,
        payload: "JWT expired",
      });
      window.location.reload();
    } else {
      yield put({
        type: SearchResultsPageEvent.GET_PAGE_DATA_RESULT,
        results: { payload, totalPages, pageNumber, totalElements },
      });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: SearchResultsPageEvent.GET_PAGE_DATA_FAIL });
  }
}
